import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// "2026-01" -> "Jan 26"
export function formatMonth(yyyyMm: string): string {
  const [y, mo] = yyyyMm.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleString("en", { month: "short", year: "2-digit" });
}

// "2026-01" -> "Jan" (no year -- for views where every month is already known
// to be the same cohort year, e.g. the enrollment-month x PLG heatmap)
export function formatMonthOnly(yyyyMm: string): string {
  const [y, mo] = yyyyMm.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleString("en", { month: "short" });
}
